var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("twilio-overview-panel", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.viewMode === "overview",
            expression: "viewMode === 'overview'",
          },
        ],
        attrs: { embedded: _vm.embedded },
        on: {
          "select-organization": _vm.onOverviewSelectOrganization,
          "go-to-detail": _vm.goToDetail,
        },
      }),
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.viewMode === "detail",
              expression: "viewMode === 'detail'",
            },
          ],
          class: _vm.$vuetify.breakpoint.xs ? "ma-1" : "ma-5",
          attrs: { flat: "", loading: _vm.loading },
        },
        [
          _c(
            "v-card-subtitle",
            {
              staticClass: "pb-1 d-flex align-center",
              staticStyle: { "min-width": "0" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-2 flex-shrink-0",
                  staticStyle: { "margin-top": "-4px" },
                  attrs: { icon: "", small: "" },
                  on: { click: _vm.backToOverview },
                },
                [_c("v-icon", [_vm._v("mdi-arrow-left")])],
                1
              ),
              _c("v-autocomplete", {
                ref: "orgAutocomplete",
                staticClass: "mb-2 org-autocomplete",
                staticStyle: { "min-width": "0", flex: "1 1 0" },
                attrs: {
                  items: _vm.organizations,
                  "item-text": "displayName",
                  "item-value": "id",
                  label: _vm.$t("twilio-debug-select-org"),
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                  loading: _vm.loadingOrgs,
                  clearable: "",
                  filter: _vm.filterOrganization,
                },
                on: { change: _vm.onOrganizationChange },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-list-item-content",
                          { staticStyle: { overflow: "hidden" } },
                          [
                            _c(
                              "v-list-item-title",
                              {
                                staticStyle: {
                                  "white-space": "nowrap",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                },
                              },
                              [
                                _vm._v(" " + _vm._s(item.displayName) + " "),
                                _c(
                                  "span",
                                  { staticClass: "text-caption grey--text" },
                                  [_vm._v("— " + _vm._s(item.id))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "selection",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "org-selection-text" }, [
                          _vm._v(" " + _vm._s(item.displayName) + " "),
                          _c(
                            "span",
                            { staticClass: "text-caption grey--text" },
                            [_vm._v("— " + _vm._s(item.id))]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedOrganizationId,
                  callback: function ($$v) {
                    _vm.selectedOrganizationId = $$v
                  },
                  expression: "selectedOrganizationId",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-subtitle",
            { staticClass: "d-flex align-center flex-wrap pt-0" },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center mr-4" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { color: _vm.healthColor, small: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.healthIcon) + " ")]
                  ),
                  _c(
                    "span",
                    {
                      class: _vm.$vuetify.breakpoint.xs
                        ? "text-body-2"
                        : "text-body-1",
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("twilio-debug-health")) + ":"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.healthLabel) + " "),
                    ]
                  ),
                ],
                1
              ),
              _vm.debugData.sipDomain
                ? _c(
                    "div",
                    {
                      staticClass: "text-caption grey--text",
                      class: { "ml-6": _vm.$vuetify.breakpoint.xs },
                    },
                    [_vm._v(" " + _vm._s(_vm.debugData.sipDomain) + " ")]
                  )
                : _vm._e(),
            ]
          ),
          _c("v-divider"),
          _vm.errorMessage
            ? _c(
                "v-alert",
                {
                  staticClass: "ma-4",
                  attrs: { type: "error", dense: "", text: "" },
                },
                [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
              )
            : _vm._e(),
          !_vm.errorMessage
            ? _c(
                "v-card-text",
                {
                  class: _vm.$vuetify.breakpoint.xs ? "pa-1" : "pa-4",
                  style: _vm.twilioContentStyle,
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-subtitle-1 font-weight-bold mb-2",
                      class: { "px-2": _vm.$vuetify.breakpoint.xs },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("twilio-debug-alerts")) + " ")]
                  ),
                  _c(
                    "v-tabs",
                    {
                      staticClass: "twilio-debug-tabs",
                      attrs: {
                        dense: "",
                        "show-arrows": _vm.$vuetify.breakpoint.xs,
                      },
                      model: {
                        value: _vm.alertTab,
                        callback: function ($$v) {
                          _vm.alertTab = $$v
                        },
                        expression: "alertTab",
                      },
                    },
                    _vm._l(_vm.alertRanges, function (range, key) {
                      return _c(
                        "v-tab",
                        {
                          key: key,
                          class: { "px-2 tab-xs": _vm.$vuetify.breakpoint.xs },
                        },
                        [
                          _c(
                            "span",
                            {
                              class: {
                                "text-caption": _vm.$vuetify.breakpoint.xs,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t(`twilio-debug-last-${range}`))
                              ),
                            ]
                          ),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                "x-small": "",
                                color:
                                  _vm.getAlerts(key).total > 0
                                    ? "red"
                                    : "green",
                                dark: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getAlerts(key).total || 0) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.alertTab,
                        callback: function ($$v) {
                          _vm.alertTab = $$v
                        },
                        expression: "alertTab",
                      },
                    },
                    _vm._l(_vm.alertRanges, function (range, key) {
                      return _c("v-tab-item", { key: key }, [
                        _c(
                          "div",
                          {
                            class: _vm.$vuetify.breakpoint.xs ? "pa-1" : "pa-3",
                          },
                          [
                            _vm.$vuetify.breakpoint.xs &&
                            _vm.getAlerts(key).byErrorCode &&
                            _vm.getAlerts(key).byErrorCode.length
                              ? _vm._l(
                                  _vm.getAlerts(key).byErrorCode,
                                  function (err) {
                                    return _c(
                                      "v-card",
                                      {
                                        key: err.errorCode,
                                        staticClass: "mb-1 error-card-mobile",
                                        class: {
                                          "error-card-critical":
                                            _vm.isCriticalError(err),
                                          "error-card-new": _vm.isNewError(
                                            err.errorCode
                                          ),
                                          "error-card-updated":
                                            _vm.isUpdatedError(err.errorCode),
                                        },
                                        attrs: {
                                          "data-error-code": err.errorCode,
                                          outlined: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-card-text",
                                          { staticClass: "pa-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-space-between",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "error-code-link font-weight-bold text-body-2",
                                                        attrs: {
                                                          href: `https://www.twilio.com/docs/api/errors/${err.errorCode}`,
                                                          target: "_blank",
                                                          rel: "noopener",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              err.errorCode
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "ml-1",
                                                            attrs: {
                                                              "x-small": "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-open-in-new"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    err.logLevel
                                                      ? _c(
                                                          "v-chip",
                                                          {
                                                            staticClass: "ml-1",
                                                            attrs: {
                                                              "x-small": "",
                                                              color:
                                                                err.logLevel ===
                                                                "ERROR"
                                                                  ? "red"
                                                                  : err.logLevel ===
                                                                    "WARNING"
                                                                  ? "orange"
                                                                  : "grey",
                                                              dark: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  err.logLevel
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text mr-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              err.lastOccurrence
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          color:
                                                            _vm.isCriticalError(
                                                              err
                                                            )
                                                              ? "red"
                                                              : "orange",
                                                          dark: "",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(err.count) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            err.description
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mb-1 mt-1 mobile-description",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          err.description
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center mt-1",
                                                staticStyle: { gap: "8px" },
                                              },
                                              [
                                                _vm
                                                  .getDistribution(err)
                                                  .some((v) => v > 0)
                                                  ? _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { bottom: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "sparkline-container sparkline-container-mobile",
                                                                          on: {
                                                                            mousemove:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onSparklineMouseMove(
                                                                                  $event,
                                                                                  key,
                                                                                  err
                                                                                )
                                                                              },
                                                                            mouseleave:
                                                                              _vm.onSparklineMouseLeave,
                                                                          },
                                                                        },
                                                                        "div",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-sparkline",
                                                                        {
                                                                          key: _vm.sparklineKey(
                                                                            err
                                                                          ),
                                                                          attrs:
                                                                            {
                                                                              value:
                                                                                [
                                                                                  ..._vm.getDistribution(
                                                                                    err
                                                                                  ),
                                                                                ],
                                                                              gradient:
                                                                                _vm.sparklineGradient(
                                                                                  err
                                                                                ),
                                                                              smooth: 10,
                                                                              padding: 2,
                                                                              "line-width": 2,
                                                                              fill: true,
                                                                              height:
                                                                                "24",
                                                                              width:
                                                                                "100",
                                                                              type: "bar",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.sparklineTooltip(
                                                                key
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                err.affectedUsers &&
                                                err.affectedUsers.length
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center flex-wrap",
                                                        staticStyle: {
                                                          gap: "2px",
                                                        },
                                                      },
                                                      _vm._l(
                                                        err.affectedUsers,
                                                        function (user) {
                                                          return _c(
                                                            "v-chip",
                                                            {
                                                              key: user.username,
                                                              class: {
                                                                "user-chip-clickable":
                                                                  !!err.distributionByUser,
                                                              },
                                                              attrs: {
                                                                "x-small": "",
                                                                outlined:
                                                                  _vm
                                                                    .selectedUserFilter[
                                                                    err
                                                                      .errorCode
                                                                  ] !==
                                                                  user.username,
                                                                color:
                                                                  _vm
                                                                    .selectedUserFilter[
                                                                    err
                                                                      .errorCode
                                                                  ] ===
                                                                  user.username
                                                                    ? "primary"
                                                                    : undefined,
                                                                dark:
                                                                  _vm
                                                                    .selectedUserFilter[
                                                                    err
                                                                      .errorCode
                                                                  ] ===
                                                                  user.username,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleUserFilter(
                                                                      err,
                                                                      user.username
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.resolveDisplayName(
                                                                      user.username
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              user.count > 1
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "ml-1 font-weight-bold",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "(" +
                                                                          _vm._s(
                                                                            user.count
                                                                          ) +
                                                                          ")"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            err.causes || err.solutions
                                              ? _c(
                                                  "v-expansion-panels",
                                                  {
                                                    staticClass:
                                                      "error-details-panels mt-1",
                                                    attrs: {
                                                      flat: "",
                                                      accordion: "",
                                                    },
                                                  },
                                                  [
                                                    err.causes
                                                      ? _c(
                                                          "v-expansion-panel",
                                                          [
                                                            _c(
                                                              "v-expansion-panel-header",
                                                              {
                                                                staticClass:
                                                                  "pa-0 error-panel-header",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption grey--text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "twilio-debug-causes"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-expansion-panel-content",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "text-caption",
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        _vm.formatMarkdown(
                                                                          err.causes
                                                                        )
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    err.solutions
                                                      ? _c(
                                                          "v-expansion-panel",
                                                          [
                                                            _c(
                                                              "v-expansion-panel-header",
                                                              {
                                                                staticClass:
                                                                  "pa-0 error-panel-header",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption grey--text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "twilio-debug-solutions"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-expansion-panel-content",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "text-caption",
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        _vm.formatMarkdown(
                                                                          err.solutions
                                                                        )
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                )
                              : _vm._e(),
                            !_vm.$vuetify.breakpoint.xs &&
                            _vm.getAlerts(key).byErrorCode &&
                            _vm.getAlerts(key).byErrorCode.length
                              ? _c("v-simple-table", {
                                  attrs: { dense: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function () {
                                          return [
                                            _c("thead", [
                                              _c("tr", [
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "twilio-debug-error-code"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "twilio-debug-message"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass: "text-center",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "twilio-debug-count"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "twilio-debug-distribution"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "twilio-debug-affected-users"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "twilio-debug-last-occurrence"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.getAlerts(key).byErrorCode,
                                                function (err) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      key: err.errorCode,
                                                      class: {
                                                        "error-row":
                                                          _vm.isCriticalError(
                                                            err
                                                          ),
                                                        "error-row-new":
                                                          _vm.isNewError(
                                                            err.errorCode
                                                          ),
                                                        "error-row-updated":
                                                          _vm.isUpdatedError(
                                                            err.errorCode
                                                          ),
                                                      },
                                                      attrs: {
                                                        "data-error-code":
                                                          err.errorCode,
                                                      },
                                                    },
                                                    [
                                                      _c("td", [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "error-code-link",
                                                            attrs: {
                                                              href: `https://www.twilio.com/docs/api/errors/${err.errorCode}`,
                                                              target: "_blank",
                                                              rel: "noopener",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  err.errorCode
                                                                ) +
                                                                " "
                                                            ),
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ml-1",
                                                                attrs: {
                                                                  "x-small": "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-open-in-new"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        err.logLevel
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mt-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-chip",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      color:
                                                                        err.logLevel ===
                                                                        "ERROR"
                                                                          ? "red"
                                                                          : err.logLevel ===
                                                                            "WARNING"
                                                                          ? "orange"
                                                                          : "grey",
                                                                      dark: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          err.logLevel
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "error-description-cell",
                                                        },
                                                        [
                                                          err.description
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text-body-2 font-weight-medium",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        err.description
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          err.causes ||
                                                          err.solutions
                                                            ? _c(
                                                                "v-expansion-panels",
                                                                {
                                                                  staticClass:
                                                                    "error-details-panels mt-1",
                                                                  attrs: {
                                                                    flat: "",
                                                                    accordion:
                                                                      "",
                                                                  },
                                                                },
                                                                [
                                                                  err.causes
                                                                    ? _c(
                                                                        "v-expansion-panel",
                                                                        [
                                                                          _c(
                                                                            "v-expansion-panel-header",
                                                                            {
                                                                              staticClass:
                                                                                "pa-0 error-panel-header",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-caption grey--text",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "twilio-debug-causes"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-expansion-panel-content",
                                                                            {
                                                                              staticClass:
                                                                                "pa-0",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-caption",
                                                                                  domProps:
                                                                                    {
                                                                                      innerHTML:
                                                                                        _vm._s(
                                                                                          _vm.formatMarkdown(
                                                                                            err.causes
                                                                                          )
                                                                                        ),
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  err.solutions
                                                                    ? _c(
                                                                        "v-expansion-panel",
                                                                        [
                                                                          _c(
                                                                            "v-expansion-panel-header",
                                                                            {
                                                                              staticClass:
                                                                                "pa-0 error-panel-header",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-caption grey--text",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "twilio-debug-solutions"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-expansion-panel-content",
                                                                            {
                                                                              staticClass:
                                                                                "pa-0",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-caption",
                                                                                  domProps:
                                                                                    {
                                                                                      innerHTML:
                                                                                        _vm._s(
                                                                                          _vm.formatMarkdown(
                                                                                            err.solutions
                                                                                          )
                                                                                        ),
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          !err.description &&
                                                          !err.causes &&
                                                          !err.solutions
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "grey--text text-caption",
                                                                },
                                                                [_vm._v("—")]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                                color:
                                                                  _vm.isCriticalError(
                                                                    err
                                                                  )
                                                                    ? "red"
                                                                    : "orange",
                                                                dark: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    err.count
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "sparkline-cell",
                                                        },
                                                        [
                                                          _vm
                                                            .getDistribution(
                                                              err
                                                            )
                                                            .some((v) => v > 0)
                                                            ? _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                            attrs,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                _vm._g(
                                                                                  _vm._b(
                                                                                    {
                                                                                      staticClass:
                                                                                        "sparkline-container",
                                                                                    },
                                                                                    "div",
                                                                                    attrs,
                                                                                    false
                                                                                  ),
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-sparkline",
                                                                                    {
                                                                                      key: _vm.sparklineKey(
                                                                                        err
                                                                                      ),
                                                                                      attrs:
                                                                                        {
                                                                                          value:
                                                                                            [
                                                                                              ..._vm.getDistribution(
                                                                                                err
                                                                                              ),
                                                                                            ],
                                                                                          gradient:
                                                                                            _vm.sparklineGradient(
                                                                                              err
                                                                                            ),
                                                                                          smooth: 10,
                                                                                          padding: 4,
                                                                                          "line-width": 2,
                                                                                          fill: true,
                                                                                          height:
                                                                                            "32",
                                                                                          width:
                                                                                            "120",
                                                                                          type: "bar",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.sparklineTooltip(
                                                                          key
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "grey--text text-caption",
                                                                },
                                                                [_vm._v("—")]
                                                              ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "td",
                                                        [
                                                          err.affectedUsers &&
                                                          err.affectedUsers
                                                            .length
                                                            ? _vm._l(
                                                                err.affectedUsers,
                                                                function (
                                                                  user
                                                                ) {
                                                                  return _c(
                                                                    "v-chip",
                                                                    {
                                                                      key: user.username,
                                                                      staticClass:
                                                                        "mr-1 mb-1",
                                                                      class: {
                                                                        "user-chip-clickable":
                                                                          !!err.distributionByUser,
                                                                      },
                                                                      attrs: {
                                                                        "x-small":
                                                                          "",
                                                                        outlined:
                                                                          _vm
                                                                            .selectedUserFilter[
                                                                            err
                                                                              .errorCode
                                                                          ] !==
                                                                          user.username,
                                                                        color:
                                                                          _vm
                                                                            .selectedUserFilter[
                                                                            err
                                                                              .errorCode
                                                                          ] ===
                                                                          user.username
                                                                            ? "primary"
                                                                            : undefined,
                                                                        dark:
                                                                          _vm
                                                                            .selectedUserFilter[
                                                                            err
                                                                              .errorCode
                                                                          ] ===
                                                                          user.username,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.toggleUserFilter(
                                                                              err,
                                                                              user.username
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.resolveDisplayName(
                                                                              user.username
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      user.count >
                                                                      1
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "ml-1 font-weight-bold",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "(" +
                                                                                  _vm._s(
                                                                                    user.count
                                                                                  ) +
                                                                                  ")"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "grey--text text-caption",
                                                                },
                                                                [_vm._v("—")]
                                                              ),
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-caption",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatDate(
                                                                  err.lastOccurrence
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            !_vm.getAlerts(key).byErrorCode ||
                            !_vm.getAlerts(key).byErrorCode.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-body-2 grey--text text-center py-3",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("twilio-debug-no-alerts")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }